module.exports = __webpack_public_path__ + "img/carousel-arrow-left-20x20.9a4bdb5d.svg";